import { render, staticRenderFns } from "./CapturePhotoModelPage.vue?vue&type=template&id=6cf9ea0a"
import script from "./CapturePhotoModelPage.vue?vue&type=script&lang=js"
export * from "./CapturePhotoModelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports